import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=3c59489a&scoped=true&"
import script from "./Navbar.ts?vue&type=script&lang=js&"
export * from "./Navbar.ts?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=3c59489a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c59489a",
  null
  
)

export default component.exports